
'use client';

import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

export default function TrustSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  const trustItems = [
    {
      icon: 'ri-shield-check-line',
      title: '7-Day Money Back',
      description: "Don't like it? Full refund, no questions asked.",
    },
    {
      icon: 'ri-lock-line',
      title: 'Secure Checkout',
      description: 'SSL encrypted. Your data is 100% protected.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Fast Shipping',
      description: 'Ships within 24 hours. Arrives in 5-7 business days.',
    },
    {
      icon: 'ri-customer-service-line',
      title: '24/7 Support',
      description: "Questions? We're here to help anytime.",
    },
  ];

  return (
    <section ref={ref} className="py-12 sm:py-16 md:py-24 lg:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-6 sm:mb-10 md:mb-16"
        >
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-black mb-2 sm:mb-4">
            Risk-Free Purchase
          </h2>
          <p className="text-black/60 text-xs sm:text-sm md:text-base lg:text-lg">
            Your satisfaction is guaranteed.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {trustItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <motion.div
                initial={{ opacity: 0, scale: 0 }}
                animate={isInView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 + 0.2 }}
                className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-2 sm:mb-3 md:mb-4 bg-black rounded-full flex items-center justify-center"
              >
                <i className={`${item.icon} text-lg sm:text-xl md:text-2xl lg:text-3xl text-white`} />
              </motion.div>
              <h3 className="font-serif text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl text-black mb-1 sm:mb-2">
                {item.title}
              </h3>
              <p className="text-black/60 text-[9px] sm:text-[10px] md:text-xs lg:text-sm leading-relaxed">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
